/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { Component } from 'react';
import { WrappedFieldMetaProps } from 'redux-form';
import { InputConfig } from '../../TaskInputs/types';
import InputContainer from '../../TaskInputs/InputContainer';
import { UnformattedTextInput } from '../../TaskInputs/TextInputWrapper';
import { addressUtils } from './utils';
import { AddressInput, TaskFieldInputProps } from './types';
import { noop } from '@utils/lodash';

export interface OwnProps {
  onClick: () => void;
  name: string;
  label: string;
  error?: string;
  value: AddressInput.Address;
}

/**
 * This component exists only to support the functionality of the mobile address input. Its
 * behavior is that when this "dummy" input is clicked, we take the click event, open a modal,
 * and pass the focus/click event from this input into the real address input. This is explicitly
 * a read-only input.
 */

class DummyAddressInput extends Component<OwnProps> {
  textInputHandlers: TaskFieldInputProps;

  constructor(props: OwnProps) {
    super(props);

    this.textInputHandlers = {
      name: props.name,
      onBlur: noop,
      onFocus: noop,
      onDragStart: noop,
      onDragEnd: noop,
      onDrop: noop,
      onKeyDown: noop,
      onChange: noop,
      value: addressUtils.dataModelAddressToString(props.value),
    };
  }

  render() {
    const { error, value, label, name, onClick } = this.props;
    const metaProps = {
      touched: true,
      error,
    } as WrappedFieldMetaProps;

    const inputConfig = {
      type: 'text',
      required: true,
      id: name,
      label,
    } as InputConfig;

    this.textInputHandlers.value = addressUtils.dataModelAddressToString(value);

    return (
      <InputContainer
        onClick={onClick}
        input={this.textInputHandlers}
        inputComponent={UnformattedTextInput}
        meta={metaProps}
        required
        config={inputConfig}
        readOnly
      />
    );
  }
}

export default DummyAddressInput;
